import * as React from 'react';
import { Text } from 'components/common/text';
import { Description } from 'models';

export interface ListingDescriptionProps {
  description?: Description;
}

export const ListingDescription: React.FunctionComponent<ListingDescriptionProps> = ({ description }) => {
  if (!description) {
    return null;
  }

  const text: Description['text'] = description && description.text;
  const theme: Description['theme'] = description && description.theme;

  return (
    text && (
      <div className="uitk-cell all-y-gutter-two uitk-type-300" data-stid="hotel-description">
        <Text theme={Text.theme[theme]}>{text}</Text>
      </div>
    )
  );
};
ListingDescription.displayName = 'ListingDescription';
